import { Navigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import CircuitOrganize from "../pages/circuits/CircuitOrganize";
import EventOrganize from "../pages/events/EventOrganize";
import OrganizationOrganize from "../pages/organizations/OrganizationOrganize";
import EventsOrganize from "../pages/organize/EventsOrganize";
import TOTokens from "../pages/organize/TOTokens";
import TicketSales from "../pages/organize/TicketSales";
import EventTokenTypes from "../pages/organize/EventTokenTypes";
import TeamOrganize from "../pages/teams/TeamOrganize";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import AccessDenied from "../pages/utility/AccessDenied";
import { getEnvironmentVariable } from "../global/environmentVariables";
import OrganizeDashboard from "../pages/organize/OrganizeDashboard";
import OrganizationsOrganize from "../pages/organize/OrganizationsOrganize";
import OrganizeCircuits from "../pages/organize/OrganizeCircuits";
import Redirect from "../components/utilities/Redirect";
import OrganizeTeams from "../pages/organize/OrganizeTeams";

const REQUIRES_ORGANIZER =
  getEnvironmentVariable("REQUIRES_ORGANIZER") === "true";
const IS_UY = getEnvironmentVariable("IS_UY") === "true";

export const organizeRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");

  return [
    {
      path: "organize",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            organize
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "organization",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizationOrganize organize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "organization/:organizationId",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizationOrganize organize setItemsMiddle={setItemsMiddle} />
          ) : (
            <Redirect path="/organization/:organizationId" />
          )
        },
        {
          path: "team",
          element: authContext?.authState?.isAuthenticated ? (
            <TeamOrganize organize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "team/:teamId",
          element: authContext?.authState?.isAuthenticated ? (
            <TeamOrganize organize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "teams",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizeTeams organize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        }
      ]
    },
    {
      path: "organize",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            organize
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "/organize/",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizeDashboard
              organize
              authContext={authContext}
              itemsMiddle={itemsMiddle}
              setItemsMiddle={setItemsMiddle}
            />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "dashboard",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizeDashboard
              organize
              authContext={authContext}
              itemsMiddle={itemsMiddle}
              setItemsMiddle={setItemsMiddle}
            />
          ) : (
            <LoginRedirect />
          )
        },

        {
          path: "events",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <EventsOrganize />
            )
          ) : (
            <LoginRedirect />
          )
        },

        {
          path: "event",
          element: authContext?.authState?.isAuthenticated ? (
            <EventOrganize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "game-stores",
          element: authContext?.authState?.isAuthenticated ? (
            <OrganizationsOrganize
              organize
              itemsMiddle={itemsMiddle}
              setItemsMiddle={setItemsMiddle}
            />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "event/:eventId",
          element: authContext?.authState?.isAuthenticated ? (
            <EventOrganize setItemsMiddle={setItemsMiddle} />
          ) : (
            <Redirect path="/event/:eventId" />
          )
        },
        {
          path: "circuits",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <OrganizeCircuits />
            )
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "tokens",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <TOTokens />
            )
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "token-types",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <EventTokenTypes />
            )
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "ticket-sales",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <TicketSales />
            )
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "token-types",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <EventTokenTypes />
            )
          ) : (
            <LoginRedirect />
          )
        },

        {
          path: "circuit",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer &&
            !authContext?.authState?.identity?.isJudge ? (
              IS_UY ? (
                <Navigate to="/subscription?subFeature=true" />
              ) : (
                <AccessDenied />
              )
            ) : (
              <CircuitOrganize setItemsMiddle={setItemsMiddle} />
            )
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "circuit/:leagueId",
          element: authContext?.authState?.isAuthenticated ? (
            <CircuitOrganize setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect />
          )
        }
      ]
    }
  ];
};
